import React from 'react'
import { Save, Undo2, Loader2, PencilLine } from 'lucide-react'

export function BrouillonBar({ count, onSave, onDiscard, saving }) {
  if (!count) return null
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 flex items-center gap-3 px-4 py-2.5 rounded-full bg-slate-900 text-white shadow-2xl border border-slate-700" data-testid="brouillon-bar">
      <PencilLine size={15} className="text-amber-300" />
      <span className="text-sm" data-testid="brouillon-count">
        <strong>{count}</strong> modification{count > 1 ? 's' : ''} non enregistrée{count > 1 ? 's' : ''}
        <span className="text-slate-400 text-xs ml-2 hidden sm:inline">· enregistrées automatiquement en quittant le dossier</span>
      </span>
      <button onClick={onDiscard} disabled={saving} className="text-xs text-slate-300 hover:text-white flex items-center gap-1 px-2 py-1 rounded hover:bg-white/10" data-testid="brouillon-annuler">
        <Undo2 size={12} /> Annuler
      </button>
      <button onClick={onSave} disabled={saving} className="text-xs font-medium bg-amber-400 text-slate-900 hover:bg-amber-300 flex items-center gap-1.5 px-3 py-1.5 rounded-full disabled:opacity-60" data-testid="brouillon-enregistrer">
        {saving ? <Loader2 size={12} className="animate-spin" /> : <Save size={12} />} Enregistrer maintenant
      </button>
    </div>
  )
}
